import React, { useState } from 'react';
import { Box, Typography, TextField, Button, CircularProgress } from '@material-ui/core';

export default function DriverLogin({ onLogin, api }) {
  const [phone, setPhone] = useState('');
  const [pin, setPin] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  async function submit(e) {
    e.preventDefault();
    if (!phone || !pin) { setError('Preencha telefone e PIN'); return; }
    setBusy(true); setError('');
    try {
      const res = await fetch(`${api}/auth/driver-login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone, pin }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Erro');
      onLogin(data);
    } catch (e) {
      setError(e.message);
      setBusy(false);
    }
  }

  return (
    <Box style={{
      minHeight: '100vh', background: 'linear-gradient(160deg, #1e293b 0%, #0f172a 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
    }}>
      <Box style={{
        width: '100%', maxWidth: 380,
        background: '#fff', borderRadius: 20, padding: '32px 28px',
        boxShadow: '0 20px 40px rgba(0,0,0,0.25)',
      }}>
        <Box style={{ textAlign: 'center', marginBottom: 24 }}>
          <Box style={{
            width: 56, height: 56, borderRadius: 14,
            background: 'linear-gradient(135deg, #3b82f6, #2563eb)',
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            marginBottom: 12,
          }}>
            <span style={{ fontSize: 28 }}>🚛</span>
          </Box>
          <Typography style={{ fontSize: '1.3rem', fontWeight: 800, color: '#0f172a' }}>
            App Motorista
          </Typography>
          <Typography style={{ fontSize: '0.8rem', color: '#64748b' }}>
            EcooGPS Planner · Acesso seguro
          </Typography>
        </Box>

        <form onSubmit={submit}>
          <TextField
            label="Telefone"
            placeholder="Ex.: 912345678"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            variant="outlined" size="small" fullWidth
            style={{ marginBottom: 12 }}
            autoFocus
          />
          <TextField
            label="PIN (últimos 4 dígitos do telefone)"
            value={pin}
            onChange={(e) => setPin(e.target.value.replace(/\D/g, '').slice(0, 4))}
            variant="outlined" size="small" fullWidth
            inputProps={{ inputMode: 'numeric', maxLength: 4 }}
            style={{ marginBottom: 14 }}
          />
          {error && (
            <Typography style={{ fontSize: '0.78rem', color: '#dc2626', marginBottom: 10 }}>
              {error}
            </Typography>
          )}
          <Button
            type="submit" variant="contained" disabled={busy} fullWidth
            style={{
              padding: '12px', borderRadius: 10, textTransform: 'none', fontSize: '0.9rem', fontWeight: 700,
              background: busy ? '#cbd5e1' : 'linear-gradient(135deg, #3b82f6, #2563eb)', color: '#fff',
            }}>
            {busy ? <CircularProgress size={18} style={{ color: '#fff' }} /> : 'Entrar'}
          </Button>
        </form>
      </Box>
    </Box>
  );
}
